/**
 * Fixed notice text shown in more than one place (PRP-MCP-4 work items 9 and 13).
 * Change the wording here only, so every screen stays the same.
 */

/** Settings, connect screen: what the MCP server records. */
export const MCP_USAGE_NOTICE =
  'Tool use and the one-line request summaries your chat app sends are recorded to improve AIEA.';

/** Export step: AIEA does not choose a price list or tax jurisdiction. */
export const XACTIMATE_PRICE_LIST_NOTICE =
  'Set the price list and tax jurisdiction in Xactimate for the loss address.';
